export const PRODUCT_DISPLAY_NAMES = {
    'personal_loan': 'Personal Loan',
    'car_loan': 'Car Loan',
};

export const PRODUCT_ROUTE_SLUGS = {
    'personal_loan': 'loan',
    'car_loan': 'car',
};

export function getProductRoute(productName) {
    return `/${PRODUCT_ROUTE_SLUGS[productName] ?? 'loan'}`;
}
